import { Modal, Row, Col, Form, useAccordionButton} from 'react-bootstrap'
import { useEffect, useState, useRef } from "react";
import { Dropdown, Button } from "react-bootstrap";
import Spinner from 'react-bootstrap/Spinner';
import { FormInputElement } from '../../Form/FormInputElement';
import AddressForm from '../../Form/AddressForm';
import { useApiClient } from '../../../ApiService/useApiClient';

const AddEditClient = ({show,setShowAddEdit, data, setdata}) => {

    const api = useApiClient();

    const formDefault = {
        opened: true,
        modalTitle:"Add New Client"        
      }
      const [formModal, setFormModal] = useState(formDefault);
      const [error,setError] = useState(null);
      const modalForm = useRef(null);
      const [validated, setValidated] = useState(false);
      const [savinginprogress, setsavinginprogress] = useState(false);

// Add state for address components
const [addressComponents, setAddressComponents] = useState({
    company_add1: '',
    company_add2: '',
    company_add3: '',
    company_add4: '',
    postcode: '',
    lat:"",
    lng:""
  });

  // Add this CSS fix for modal z-index issue
const autocompleteStyles = `
.pac-container {
  z-index: 1051 !important; /* Must be higher than modal's z-index (1050) */
}
`;


const isAtLeast15YearsOld = (dobStr) => {
  const dob = new Date(dobStr);
  const today = new Date();
  const age = today.getFullYear() - dob.getFullYear();
  const m = today.getMonth() - dob.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
    return age - 1;
  }
  return age;
};

  useEffect(() => {
    // Create style element
    const style = document.createElement('style');
    style.innerHTML = `.pac-container { z-index: 2000 !important; }`;
    document.head.appendChild(style);
  
    // Clean up
    return () => {
      document.head.removeChild(style);
    };
  }, []);


      useEffect(()=>{

        setFormModal({...formModal, opened:show , action:'add'});

      },[show]);

      
    function closeFormModal(){
        const updateFormModal = {...formModal, opened:false}
        setFormModal(updateFormModal);
        setShowAddEdit(false);
      }
  

      function handleAddEvent(e){        
        //closeFormModal();
        //e.preventDefault();
    }

    function handleEditEvent(e){
      // const updatedEvents = events.filter((item) => item.id !== selectedEvent.id)
      // setEvents(updatedEvents);
      //closeFormModal();
      //e.preventDefault();
  }


  // Google Places handler
const handleAddressSelect = (place) => {
    const components = {};
    if (!place.address_components) return;
    place.address_components.forEach(component => {
      component.types.forEach(type => {
        components[type] = component.long_name;
      });

      if (place.geometry && place.geometry.location) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        components["lat"] = lat;
        components["lng"] = lng;
        // Use lat/lng as needed
      }

      console.log(components);

    });
  
    setAddressComponents({
      company_add1: `${components.street_number || ''} ${components.route || ''}`.trim(),
      company_add2: components.sublocality_level_1 || '',
      company_add3: components.locality || components.postal_town || '',
      company_add4: components.administrative_area_level_2 || '',
      postcode: components.postal_code || '',
      lat:components.lat ||"",
      lng:components.lng ||""
    });
  };
  
  // Geoapify handler (alternative)
//   const handleGeoapifySearch = async (query) => {
//     if (query.length < 3) return;
    
//     try {
//       const response = await axios.get(
//         `https://api.geoapify.com/v1/geocode/autocomplete`,
//         {
//           params: {
//             text: query,
//             apiKey:'afbb4c9b5c494dfe9470a39f5b44ac10', // 'AIzaSyBPnUpAxvQT4cvrFReSUr3NeHORyF58ahE',
//             limit: 10
//           }
//         }
//       );
  
//       // Process Geoapify response
//       const suggestion = response.data.features[0].properties;
//       setAddressComponents({
//         company_add1: suggestion.address_line1,
//         company_add2: suggestion.address_line2,
//         company_add3: suggestion.city,
//         company_add4: suggestion.county,
//         postcode: suggestion.postcode
//       });
//     } catch (error) {
//       console.error('Geoapify error:', error);
//     }
//   };


      const handleFormSubmit=(event)=>{
       
            setsavinginprogress(true);

        const form = event.currentTarget;

        //console.log(form.checkValidity());
        //return null

        if (form.checkValidity() === false) {
            
            event.preventDefault();
            event.stopPropagation();                 
          }
          else          
          {        
            event.preventDefault();
            let title = modalForm.current.querySelector('#title').value; 
            let Fname = modalForm.current.querySelector('#Fname').value; 
            let Lname = modalForm.current.querySelector('#Lname').value; 
            let EmailAddress = modalForm.current.querySelector('#EmailAddress').value; 
            let MobileNo = modalForm.current.querySelector('#MobileNo').value; 
            let TelNo = modalForm.current.querySelector('#TelNo').value; 
            let hns_number = modalForm.current.querySelector('#hns_number').value; 
            let company_add1 = modalForm.current.querySelector('#company_add1').value; 
            let company_add2 = modalForm.current.querySelector('#company_add2').value; 
            let company_add3 = modalForm.current.querySelector('#company_add3').value; 
            let company_add4 = modalForm.current.querySelector('#company_add4').value;         
            let postcode = modalForm.current.querySelector('#postcode').value; 
            //let dateofbirth = modalForm.current.querySelector('#dateofbirth').value; 

let dateofbirth = modalForm.current.querySelector('#dateofbirth').value;

// Validate Date of Birth: must be at least 15 years old
const age = isAtLeast15YearsOld(dateofbirth);
if (age < 18) {
  setError("Client must be at least 18 years old.");
  event.preventDefault();
  event.stopPropagation();
  return;
}


            
            let gender = modalForm.current.querySelector('#gender').value; 
                        
        
    
            const frmFormData = new FormData();
            frmFormData.append("Title", title) 
            frmFormData.append("FirstName", Fname) 
            frmFormData.append("LastName", Lname)  
            frmFormData.append("EmailAddress", EmailAddress)  
            frmFormData.append("MobileNo", MobileNo)  
            frmFormData.append("CompanyTelNo", TelNo)  
            frmFormData.append("HnsNumber", hns_number)          
            frmFormData.append("CompanyAdd1", company_add1)  
            frmFormData.append("CompanyAdd2", company_add2)  
            frmFormData.append("CompanyAdd3", company_add3)  
            frmFormData.append("CompanyAdd4", company_add4)  
            frmFormData.append("Postcode", postcode)  
            frmFormData.append("DateOfBirth", dateofbirth)  
            frmFormData.append("Gender", gender)                        

            //console.log(frmFormData);

            const sURL = "HMCareData/customer/add/";
                      
            api.post(sURL,frmFormData)
            .then((Response)=>{

                let updatedDataObj = Response.data;  
                //console.log({updatedDataObj})
                setdata([...data, updatedDataObj])          
                closeFormModal();    

            }).catch(error => {
                setError(error);     
                console.log({error})
            });            
        }   

    setValidated(true);
    event.preventDefault();
    setsavinginprogress(false);
    
    }

//    console.log(formModal.opened);

  return (
    <Modal show={formModal.opened} onHide={closeFormModal} size="lg" backdrop="static" >
<Form ref={modalForm} onSubmit={handleFormSubmit} noValidate validated={validated} >
    <Modal.Header closeButton>
    <Modal.Title className="event-title" as="h4">{formModal.modalTitle}</Modal.Title>
    </Modal.Header>                
    <Modal.Body>

        {false && <Spinner animation="border" variant="primary" />}             

        {<Row className="g-gs">
            <Col xs="2">
                <Form.Group>
                    <Form.Label htmlFor="eventTitle">Title</Form.Label>
                    <Form.Select id="title" defaultValue={formModal.title}>                                
                        <option value="Mr">Mr</option>
                        <option value="Mrs">Mrs</option>                                
                        <option value="Ms">Ms</option>                                                                                     
                    </Form.Select>
                </Form.Group>
            </Col>

            <FormInputElement type="text" id="Fname" ColWidth={4} maxLength={100} Label="First Name" defaultValue={formModal.Fname}  placeholder="First Name(s)" required/>
            <FormInputElement type="text" id="Lname" ColWidth={6} maxLength={150} Label="Last Name" defaultValue={formModal.Lname}  placeholder="Last Name" required/>
            <FormInputElement type="text" id="EmailAddress" ColWidth={6} maxLength={100} Label="Email Address" defaultValue={formModal.EmailAddress}  placeholder="Email Address" required/>
            <FormInputElement type="text" id="MobileNo" ColWidth={6} maxLength={100} Label="Mobile Number" defaultValue={formModal.MobileNo}  placeholder="Mobile Number" required/>
            <FormInputElement type="text" id="TelNo" ColWidth={6} maxLength={12} Label="Home Phone" defaultValue={formModal.TelNo}  placeholder="Home Phone"/>
            <FormInputElement type="text" id="hns_number" ColWidth={6} maxLength={15} Label="NHS Number" defaultValue={formModal.hns_number}  placeholder="NHS Number"/>
            <FormInputElement type="date" id="dateofbirth" ColWidth={6} maxLength={15} Label="Date of birth" defaultValue={formModal.dateofbirth}  placeholder=""/>
            {error && <p className="text-danger fw-bold">{error}</p>}

            <Col xs="6">
                <Form.Group>
                    <Form.Label htmlFor="eventTitle">Gender</Form.Label>
                    <Form.Select id="gender" defaultValue={formModal.gender} value={formModal.gender} required onChange={e => setFormModal({ ...formModal, gender: e.target.value })}>                                
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>                                
                        <option value="">Prefer not to say</option>                                                                                     
                    </Form.Select>
                </Form.Group>
            </Col>

            
            <Col xs="10">            
                <Form.Group>

                <AddressForm
                        address={addressComponents}
                        setAddress={setAddressComponents}
                        validated={validated}
                        />
                       
                </Form.Group>
            </Col>


            




            {/* <Col sm="6">
                <Form.Group>
                    <Form.Label htmlFor="eventStartDate" >Starts Date/Time</Form.Label>
                    <Row className="g-2">
                        <Col xs="7">
                            <div className="form-control-wrap">
                                <DatePicker id="eventStartDate" value={formModal.eventStartDate} placeholder="yyyy-mm-dd"/>
                            </div>
                        </Col>
                        <Col xs="5">
                            <div className="form-control-wrap">
                                <TimePicker id="eventStartTime" value={formModal.eventStartTime} placeholder="hh:mm"/>
                            </div>
                        </Col>
                    </Row>
                </Form.Group>
            </Col>
            <Col sm="6">
                <Form.Group>
                    <Form.Label htmlFor="eventEndDate">End Date/Time</Form.Label>
                    <Row className="g-2">
                        <Col xs="7">
                            <div className="form-control-wrap">
                                <DatePicker id="eventEndDate" value={formModal.eventEndDate} placeholder="yyyy-mm-dd"/>
                            </div>
                        </Col>
                        <Col xs="5">
                            <div className="form-control-wrap">
                                <TimePicker id="eventEndTime" value={formModal.eventEndTime} placeholder="hh:mm"/>
                            </div>
                        </Col>
                    </Row>
                </Form.Group>
            </Col>  
            <Col xs="12">
                <Form.Group>
                    <Form.Label htmlFor="eventDescription">Admin Notes</Form.Label>
                    <div className="form-control-wrap">
                        <Form.Control id="eventDescription" as="textarea" placeholder="Admin Notes" defaultValue={formModal.eventDescription} />
                    </div>
                </Form.Group>
            </Col>                 

            <Col xs="6">                        
            <Form.Label>Funding </Form.Label>
                <div className="form-control-wrap">
                    <Form.Select id="fundingType" value={formModal.fundingType}>                                
                        <option value="client">Client</option>
                        <option value="council">Council</option>                                
                    </Form.Select>
                </div>
            </Col> */}
        </Row>}
    </Modal.Body>
    <Modal.Footer>                    
        <Button variant="danger" onClick={closeFormModal}>Discard</Button>
        {formModal.action === 'add' && !savinginprogress && <Button variant="primary" type="submit" onClick={handleAddEvent}>Add Client</Button>}
        {formModal.action === 'add' && savinginprogress && <Button variant="primary" type="submit" >Saving...</Button>}
        {formModal.action === 'edit' && !savinginprogress && <Button variant="primary" type="submit" onClick={handleEditEvent}>Update Client</Button>}
        {formModal.action === 'edit' && savinginprogress && <Button variant="primary" type="submit" >Saving...</Button>}
    </Modal.Footer>
</Form>
</Modal>
  )
}

export default AddEditClient